// frontend/src/components/NavbarClinica.jsx
import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

export default function NavbarClinica() {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      <header className="bg-gray-800 text-white shadow-md">
        <div className="container mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="mr-4">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 12h16" />
              </svg>
            </button>
            <img src="/logo.png" alt="FisioWeb" className="h-10 w-auto" />
          </div>

          {/* Clique no nome/ícone navega para /clinica/perfil — igual ao fisio */}
          <div
            className="flex items-center cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => navigate('/clinica/perfil')}
            title="Editar perfil da clínica"
          >
            <span className="hidden sm:block mr-2 text-sm">{user?.nome || 'Clínica'}</span>
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
        </div>
      </header>

      <aside className={`bg-gray-700 text-white w-64 min-h-screen p-4 fixed top-0 left-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out z-30 flex flex-col`}>
        <div className="flex-shrink-0">
          <div className="flex justify-between items-center mb-6">
            <h2 className="font-bold text-2xl">Menu</h2>
            <button onClick={() => setIsOpen(false)} className="text-white hover:text-gray-300">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <nav className="flex-grow overflow-y-auto">
          <ul>
            <li className="mb-3"><Link to="/clinica/dashboard" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Painel</Link></li>
            <li className="mb-3"><Link to="/clinica/pacientes" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Pacientes</Link></li>
            <li className="mb-3"><Link to="/clinica/pilates" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Pilates</Link></li>
            <li className="mb-3"><Link to="/clinica/financeiro" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Financeiro</Link></li>
          </ul>
        </nav>

        <div className="mt-auto flex-shrink-0">
          <div className="border-t border-gray-600 pt-4">
            {/* Clique no nome do menu lateral também vai para perfil */}
            <div
              className="flex items-center mb-4 cursor-pointer hover:opacity-80"
              onClick={() => { setIsOpen(false); navigate('/clinica/perfil'); }}
            >
              <svg className="w-8 h-8 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              <span className="font-medium">{user?.nome || 'Carregando...'}</span>
            </div>
            <button onClick={handleLogout} className="w-full text-left flex items-center bg-red-500 hover:bg-red-600 text-white p-2 rounded-md text-sm font-medium">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Sair
            </button>
          </div>
        </div>
      </aside>

      {isOpen && <div className="fixed inset-0 bg-black opacity-50 z-20" onClick={() => setIsOpen(false)} />}
    </>
  );
}